import styled from 'styled-components';
import { SColumn } from 'styles/layout';

export const SSubCards = styled(SColumn)`
    width: 100%;
    gap: 1rem;
`;
